import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompaniesService } from '@core/services/companies.service';
import { UsersService } from '@core/services/users.service';
import { Compagnie, User } from '@shared/models';
import { snackbars, snackbarsMsg } from '@workers';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardSubtitle,
  MatCardContent,
  MatCardActions,
  MatCardFooter,
} from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-compagnie-link-form',
  templateUrl: './compagnie-link-form.component.html',
  styleUrls: ['./compagnie-link-form.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatDivider,
    MatCardContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatIcon,
    MatSuffix,
    MatCardActions,
    MatButton,
    MatCardFooter,
    MatProgressBar,
    AsyncPipe,
  ],
})
export class CompagnieLinkFormComponent implements OnInit {
  private formBuilder = inject(FormBuilder);

  private companiesService = inject(CompaniesService);

  data = inject<User>(MAT_DIALOG_DATA);

  private dialogRef =
    inject<MatDialogRef<CompagnieLinkFormComponent>>(MatDialogRef);

  private usersService = inject(UsersService);

  private snackBar = inject(MatSnackBar);

  form: FormGroup;

  formInProgress: boolean = false;

  companies: Observable<{ data: Compagnie[]; length: number; page: number }>;

  user: User;

  ngOnInit(): void {
    this.companies = this.companiesService
      .getAll({ page: 1, limit: 50 })
      .pipe(first());

    this.form = this.formBuilder.group({
      compagnie: ['', Validators.required],
    });

    if (this.data) {
      this.user = this.data;
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const { compagnie } = this.form.value;
    const formValue = { id: this.user.id, compagnie } as Pick<
      User,
      'id' | 'compagnie'
    >;
    this.usersService
      .update(this.data.id, formValue as User)
      .pipe(first())
      .subscribe(
        () => {
          this.snackBar.open(snackbarsMsg.updateSucceed, '', snackbars.success);
          this.formInProgress = false;
          this.cancel();
        },
        () => {
          this.snackBar.open(snackbarsMsg.updateFailed, '', snackbars.error);
          this.formInProgress = false;
        }
      );
  }
}
